import React, { Component, Fragment, useRef, useState, useMemo } from 'react'
import ReactECharts from 'echarts-for-react';
import { Row, Col, Image, Card, Typography, Switch } from 'antd'
import {prUrl, osintRequestAddress} from './config.js'
import { translate } from '../utils'
import axios from 'axios';

const { Title, Paragraph } = Typography;

var nodes = Array(0)
var relations = Array(0)
const constOptions = {
    title: {
        text: ''
    },
    // tooltip: {},     //默认提示框，提示节点name
    tooltip: {                
        formatter: function (x) {
            if (x.dataType==="node"){
                return x.data.name + (x.data.type ? "（"+x.data.type+"）":'');   
            }else{
                if (x.dataType==="edge"){
                    return x.data.value    
                }else{
                    return ''
                }
            }            
       }
    },
    // animationDurationUpdate: 100,
    // animationEasingUpdate: 'quinticInOut',
    // itemStyle: {  // 给节点加上阴影，显着立体
    //     shadowColor: '#C0C0C0', 
    //     shadowOffsetX: 2,
    //     shadowOffsetY: 2
    // },
    symbolSize: 60, //全局节点尺寸
    label: {
        normal: {
            show: true,
            textStyle: {
                fontSize: 12
            },
        }
    },
    color: ['#F4A460','#6495ED'],
    series: [
        {
            type: 'graph',
            layout: 'force',
            symbolSize: 45,
            focusNodeAdjacency: true,   
            roam: true, //开启鼠标平移及缩放
            // draggable: true, //节点是否支持鼠标拖拽。     
            categories: [
                {
                    name: 'center',
                    symbolSize: 80,
                },
                {
                    name: 'others',
                },
            ],
            label: {
                normal: {
                    show: true,
                    textStyle: {
                        fontSize: 12,
                        color: '#ffffff',
                        // fontStyle: 'normal', //文字风格，normal，italic，oblique 三种可选
                    },
                }
            },
            // labelLayout: {
            //     moveOverlap: 'shiftX', //标签重叠时，挪动标签防止重叠
            //     draggable: true //节点标签是否允许鼠标拖拽定位
            // },
            force: {
                initLayout: 'circular',
                repulsion: 500, //斥力大小
                edgeLength: 160,    //节点连线长度
                layoutAnimation: false,
                gravity: 0.1,
            },
            edgeSymbol: ['', 'arrow'],    //两节点连线的尾和头的样式  ['circle', 'arrow']
            edgeSymbolSize: [8, 8], 
            cursor: 'pointer', //鼠标悬浮时在图形元素上时鼠标的样式
            edgeLabel: {
                normal: {
                    show: true,
                    textStyle: {
                        fontSize: 12,
                        color: '#ffffff',
                    },
                    formatter: "{c}"
                }
            },
            data: [],
            links: [],
            lineStyle: {
                normal: {
                    opacity: 0.9,
                    width: 1,
                    curveness: 0.1,
                }
            },
            autoCurveness: 0.01, //多条边的时候，自动计算曲率
        }
    ]
}; 

class WikiCard extends Component {
    state = {
        showWikiWord: this.props.initWikiWord,
        transed: false, 
        loading: false,
        transText: '',
    }

    setShowWikiWordByRef = (ww)=>{
        this.setState({
            showWikiWord: ww,
            transed: false, 
            loading: false,
            transText: '',
        })
    }

    setTransResult = (t)=>{
        this.setState({transText:t, transed:true, loading:false})
    }

    trans =()=>{
        if (!this.state.transed){
            this.setState({loading:true})
            translate(this.state.showWikiWord.content, this.setTransResult)
        }else{
            this.setState({transed:false, loading:false})
        }        
    }

    render(){
        const {showWikiWord, transed, loading, transText} = this.state
        return (
            <Card title={<Title level={5} style={{textAlign:'center', color:'white'}}>{"实体详情"}</Title>} 
                bordered={false} style={{ height:'65vh' }}>
                {
                    showWikiWord ?
                    <Fragment>
                        {showWikiWord.encryptedImageUrl && 
                            <Row align='middle' justify='center'>
                                <Image src={prUrl+showWikiWord.encryptedImageUrl} preview={false} height={'12vw'}/>
                            </Row>}                  
                            <Title level={5} style={{textAlign:'center', color:'white'}}><a href={prUrl+showWikiWord.encryptedUrl} target="blank">
                                {showWikiWord.title}</a>
                            </Title>
                            {
                                showWikiWord.language === "en"?
                                <Col span={4} offset={20}>
                                    <Switch checkedChildren="中" unCheckedChildren="英" checked={transed} loading={loading } onClick={this.trans} size={'small'}/>
                                </Col>:''
                            }
                        <Paragraph ellipsis={{rows:13}} style={{color:'white', "text-indent":"50px"}}>{transed?transText:showWikiWord.content}</Paragraph>
                    </Fragment>:''
                }            
            </Card>
        )
    }
}

const KnowledgeGraph = (props)=> {
    const [center, setCenter] = useState(props.wikiWord)       
    const [otherNodes, setOtherNodes] = useState(props.kgData)
    const wikiCardRef = useRef()
    var timer

    const onChartClick = (param)=>{
        console.log(param);
        clearTimeout(timer)
        timer = setTimeout(()=>{
            wikiCardRef.current.setShowWikiWordByRef({}) 
            if (param.data.id){
                const {id} = param.data
                if (id){
                    axios.get(`${osintRequestAddress}/wiki?content=n&qcode=${id}`).then(
                        response => {
                            if (response.data && response.data.wikipedia && response.data.wikipedia.length>0){
                                wikiCardRef.current.setShowWikiWordByRef(response.data.wikipedia[0])                    
                            }                      
                        },
                        error => {console.log("error",error)}
                    )
                }
            }  
        },500)      // 采用计时器防止EChats混淆单击双击
    }

    const onChartDbClick = (param)=>{
        clearTimeout(timer)
        if (param.data.id){
            const {id} = param.data
            if (id){
                axios.get(`${osintRequestAddress}/kg?content=nr&maxrel=30&qcode=${id}`).then(    // 限制最多返回30个关系节点
                    response => {
                        if (response.data && response.data.wikipedia && response.data.wikipedia.length>0){
                            if (response.data.relatedNodes && response.data.relatedNodes.length>0){
                                setCenter(response.data.wikipedia[0])
                                setOtherNodes(response.data.relatedNodes)
                                wikiCardRef.current.setShowWikiWordByRef(response.data.wikipedia[0])
                            }
                        }                      
                    },
                    error => {console.log("error",error)}
                )
            }
        }  
    }

    const getOptions = (wikiWord,kgData) => {
        var kgOptions = constOptions
        if (wikiWord && kgData && kgData.length>0){            
            if (!nodes || nodes.length=== 0){
                nodes.push({id:wikiWord.qcode, name:wikiWord.title, url:wikiWord.wiki, category:'center'})
            }
            for (var d in kgData){
                var index = nodes.findIndex((n)=> n.id === kgData[d].qcode)
                if (index === -1) {    //没找到
                    nodes.push({id: kgData[d].qcode, name:kgData[d].label, url:kgData[d].wiki, category:'others'})                    
                }
                if (kgData[d].direction){
                    relations.push({source: wikiWord.qcode, target: kgData[d].qcode, value: kgData[d].relation}) // 正向关系
                }else{
                    relations.push({source: kgData[d].qcode, target: wikiWord.qcode, value: kgData[d].relation}) // 反向关系
                }
            }
            kgOptions.series[0].data = nodes
            kgOptions.series[0].links = relations
        }
        return kgOptions
    }

    useMemo(()=>{
        nodes = [];
        relations = [];
    },[])

    return (
        <Row align='middle' justify='center'>
            <Col span={16} > 
                <ReactECharts option={getOptions(center,otherNodes)} onEvents={{'click': onChartClick, 'dblclick':onChartDbClick}} style={{height:"65vh"}}/>
            </Col>
            <Col span={8}> 
                <WikiCard ref={wikiCardRef} initWikiWord={props.wikiWord}></WikiCard>
            </Col>
        </Row>
    ) 
} 

export default KnowledgeGraph;

